import { render, staticRenderFns } from "./ViaticComponent.vue?vue&type=template&id=59638e3a"
import script from "./ViaticComponent.vue?vue&type=script&lang=js"
export * from "./ViaticComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports